import { useMemo } from 'react';

import { NAVIGATION_LINKS } from '~/consts/navigation';

import { UserType } from '~/types/responses/users';

import featureToggleUtils from '~/utils/featureToggle';

export default function useNavigationLinks(user: App.User | UserType) {
  const navLinks = useMemo(() => {
    if (!user) {
      return [];
    }

    const hasAccess = (navLink: App.NavigationLink) =>
      featureToggleUtils.availableToShow(navLink.featureToggle) &&
      (!navLink.requiredRoles?.size || // has no required roles
        user.roles.some((role) => navLink.requiredRoles.has(role))); // user has sufficient roles

    const filterNavLinks = (navLinksList: Array<App.NavigationLink>): Array<App.NavigationLink> =>
      navLinksList.reduce<Array<App.NavigationLink>>((acc, navLink) => {
        if (!hasAccess(navLink)) {
          return acc;
        }

        if (!navLink.subLinks?.length) {
          return acc.concat(navLink);
        }

        return acc.concat({
          ...navLink,
          subLinks: filterNavLinks(navLink.subLinks),
        });
      }, []);

    return filterNavLinks(NAVIGATION_LINKS);
  }, [user]);

  return navLinks;
}
